import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FD100MultiSelectOptions } from '../../Plateforme/Utils/Listings';
import { Link } from 'react-router-dom';
import FabFrIndicator from '../../Plateforme/Atoms/FabFrIndicator';
import { getEventDesignerDisplayName, getEventDesignerProfileLink } from './utils/eventDesignerHelpers';

const ColorBlock = styled.div`
    width: 50px;
    height: 30px;
    border-radius: 5px;
`

const FDProjetsList = (props) => {
    const { i18n } = useTranslation();

    const [statusFilter, setStatusFilter] = React.useState("")
    const [typeFilter, setTypeFilter] = React.useState("")
    const [categorieFilter, setCategorieFilter] = React.useState("")
    const [verificationFilter, setVerificationFilter] = React.useState("");
    const [sortBy, setSortBy] = React.useState("companyName");

    let fabricantsString = ""
    props.projets.forEach((projet) => {
        if(projet.projet.fabricants) {
            try {
                const fabricants = JSON.parse(projet.projet.fabricants);
                if (Array.isArray(fabricants)) {
                    fabricants.forEach((fabricant) => {
                        if (fabricant && fabricant.name) {
                            fabricantsString += fabricant.name.toLowerCase() + "\n";
                        }
                    });
                }
            } catch (error) {
                console.error("Error parsing fabricants JSON for project:", projet, error);
            }
        }
    });
    console.log(fabricantsString);

    let editorsString = ""
    props.projets.forEach((projet) => {
        if(projet.projet.editeur) {
            const editeur = projet.projet.editeur;
            if (editeur) {
                editorsString += editeur + "\n";
            }
        }
    });
    console.log(editorsString);

    //then print the how many editors we have
    const editorsArray = editorsString.split("\n").filter((editor) => editor.trim() !== "");
    const uniqueEditors = [...new Set(editorsArray)];
    console.log("Unique editors:", uniqueEditors);

    const tyoplogieEspaceFD100 = FD100MultiSelectOptions.tyoplogieEspaceFD100("fr");
    const typologieObjetFD100 = FD100MultiSelectOptions.typologieObjetFD100("fr");

    //there are two types of categories, espace and objet, we merge them, but we need to remove the duplicates
    const FDCategories = [
        ...tyoplogieEspaceFD100,
        ...typologieObjetFD100,
    ].filter((cat, index, self) => self.findIndex((t) => t.value === cat.value) === index);

    function sortProjectsByParticipationCreationDate(a, b) {
        const dateA = new Date(a.user.participation.createdAt);
        const dateB = new Date(b.user.participation.createdAt);
    
        if (dateA < dateB) return 1;
        if (dateA > dateB) return -1;
    
        //fallback: compare by project name to ensure stable sort
        if (a.projet.name < b.projet.name) return -1;
        if (a.projet.name > b.projet.name) return 1;

        // fallback: compare by project ID to ensure stable sort
        return a.projet?._id?.localeCompare(b.projet?._id);
    }

    function sortProjectsByCompanyName(a, b) {
        const companyA = getEventDesignerDisplayName(a.projet, a.user).toLowerCase();
        const companyB = getEventDesignerDisplayName(b.projet, b.user).toLowerCase();
        if (companyA < companyB) return 1;
        if (companyA > companyB) return -1;

        //fallback: compare by project name to ensure stable sort
        if (a.projet.name < b.projet.name) return 1;
        if (a.projet.name > b.projet.name) return -1;

        // fallback: compare by project ID to ensure stable sort
        return a.projet?._id?.localeCompare(b.projet?._id);
    }

    function filterProjects(projet) {
        let color = "yellow"
        if(projet.projet.status === "validé"){
            color = "green"
        }
        if(projet.projet.status === "refusé"){
            color = "red"
        }

        function colorToStatus(color){
            if(color === "green") return "validé"
            if(color === "red") return "refusé"
            return "à valider"
        }

        if (statusFilter && colorToStatus(color) !== statusFilter) return false; // filtering
        if (typeFilter && projet.projet.type !== typeFilter) return false; // filtering
        if (categorieFilter && projet.projet.typologie !== categorieFilter) return false; // filtering
        if (verificationFilter && projet.projet.projet_verifie_fd100_2025 !== verificationFilter) return false; // filtering
        if (!projet.projet.name || !projet.user.hsCompany?.properties?.name) return false; // remove empty lines or lines with no project

        return true; // keep the project
    }

    const filteredProjects = props.projets
        .sort(sortBy === "participationCreationDate" ? sortProjectsByParticipationCreationDate : (sortBy === "companyName" ? sortProjectsByCompanyName : (a, b) => 0)) // default sort if no valid sortBy is set
        .reverse()
        .filter(projet => projet.projet.name)
        .filter(filterProjects);

    return (
        <div className='companies_cont'>
            <h3 className='blacklower'>Sociétés et projets</h3>
            <div className='flexinfos'>
                <h3>Filtres :</h3>
                <span>Validation :&nbsp;
                    <select value={statusFilter} onChange={(e)=>setStatusFilter(e.target.value)}>
                        <option value="">Tous</option>
                        <option value="à valider">À valider</option>
                        <option value="validé">Validé</option>
                        <option value="refusé">Refusé</option>
                    </select>
                </span>
                <span>Type :&nbsp;
                    <select value={typeFilter} onChange={(e)=>setTypeFilter(e.target.value)}>
                        <option value="">Tous</option>
                        <option value="espace">Espace</option>
                        <option value="objet">Objet</option>
                    </select>
                </span>
                <span>Typologie :&nbsp;
                    <select value={categorieFilter} onChange={(e)=>setCategorieFilter(e.target.value)}>
                        <option value="">Tous</option>
                        {FDCategories.map((cat,i) => 
                            <option value={cat.value} key={i}>{cat.label}</option>
                        )}
                    </select>
                </span>
                <span>Vérification :&nbsp;
                    <select value={verificationFilter} onChange={(e)=>setVerificationFilter(e.target.value)}>
                        <option value="">Tous</option>
                        <option value="oui">Vérifiés</option>
                        <option value="non">Non vérifiés</option>
                    </select>
                </span>
            </div>
            <div>
                <span>Tri :&nbsp;
                    <select value={sortBy} onChange={(e)=>setSortBy(e.target.value)}>
                        <option value="participationCreationDate">Date de création de la participation</option>
                        <option value="companyName">Nom du studio</option>
                    </select>
                </span>
            </div>
            <br/>
            {filteredProjects.length} projet(s) trouvé(s)
            {filteredProjects.map((projet, i) => {
                let color = "yellow"
                if(projet.projet.status === "validé"){
                    color = "green"
                }
                if(projet.projet.status === "refusé"){
                    color = "red"
                }

                // function colorToStatus(color){
                //     if(color === "green") return "validé"
                //     if(color === "red") return "refusé"
                //     return "à valider"
                // }

                // //make the string lowercase, and the first letter uppercase
                // function quentinCase(string){
                //     return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
                // }

                //make the string lowercase, and the first letter of each word uppercase
                function quentinCase(string){
                    return string.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
                }
                // console.log("projet from FDProjetsList")
                // console.log(projet)

                function badCategoryVia(cat_via_string){

                    if(!cat_via_string) return "";

                    if(cat_via_string.toLowerCase().includes("fabricant") || cat_via_string.toLowerCase().includes("éditeur") || cat_via_string.toLowerCase().includes("editeur")){
                        return cat_via_string.split(";").join(" / ");
                    }

                    return "";
                }

                // if(statusFilter && colorToStatus(color) !== statusFilter) return null; //filtering
                // if(typeFilter && projet.projet.type !== typeFilter) return null; //filtering
                // if(categorieFilter && projet.projet.typologie !== categorieFilter) return null; //filtering
                // if(!projet.projet.name || !projet.user.hsCompany?.properties?.name) return null; // remove empty lines or lines with no project
                // if(verificationFilter && projet.projet.projet_verifie_fd100_2025 !== verificationFilter) return null; //filtering
                return (
                    <div className='company' key={projet.projet._id + projet.projet.name + projet.user.participation._id} style={{backgroundColor: projet?.projet?.projet_verifie_fd100_2025 === "oui" ? "#ebf7eb" : "white"}}>
                        <div style={{width:"35%"}}>
                            <Link to={"/evenements/fd100editparticipation?eid="+props.event._id+"&uid="+projet.user.user._id+""} target='_blank'>
                                <b className='linkbutton title'>{getEventDesignerDisplayName(projet.projet, projet.user)}</b>
                            </Link>&nbsp;<input type="checkbox" checked={projet.projet.candidate_as_person_fd100_25 === "oui"} onChange={(e)=>{props.updateProjetCandidatingAsStatus(projet.user.participation._id,projet.user?.company?._id,projet.projet._id,e.target.checked ? "oui" : "non")}}/><span style={{fontSize:"12px"}}>Candidate&nbsp;en tant que personne</span>
                            <br/>
                            <Link 
                                to={getEventDesignerProfileLink(projet.projet, projet.user)} 
                                target='_blank'
                                style={{color:"black", fontSize:"0.8em"}}
                            >
                                Fiche candidat
                            </Link>
                            <br/>
                            <span className='red'>{badCategoryVia(projet.user.hsCompany?.properties?.cat_gorie_via)}</span>
                            {projet.projet.name && <>
                                <Link to={"/admin/events/fdficheprojet?email="+projet.user.user.email+"&pid="+projet.user.participation._id+"&projid="+projet.projet._id+"&edit-mode=true"} target='_blank'>
                                    <div className='linkbutton title' style={{color:"black"}}>{quentinCase(i18n.language !== 'fr' && projet.projet.name_en ? projet.projet.name_en : projet.projet.name)}{projet.projet.fabrication_fr === "oui" && <FabFrIndicator/>}</div>
                                </Link>
                                <select value={projet.projet.typologie || ""} onChange={(e)=>{props.updateProjetCategorie(projet.user.participation._id,projet.projet._id,e.target.value)}}>
                                    <option value="">Catégorie</option>
                                    {FDCategories.map((cat,i) => 
                                        <option value={cat.value} key={i}>{cat.label}</option>
                                    )}
                                </select>
                                <input type="checkbox" checked={projet.projet.projet_verifie_fd100_2025 === "oui"} onChange={(e)=>{props.updateProjetVerificationStatus(projet.user.participation._id,projet.user?.company?._id,projet.projet._id,e.target.checked ? "oui" : "non")}}/><span style={{fontSize:"12px"}}>Candidature&nbsp;vérifiée</span>
                            </>}
                       </div>
                       {projet.projet.name && <>
                            <ColorBlock style={{backgroundColor:color}}/>
                            <select value={projet.projet.status || "à valider"} onChange={(e)=>{props.updateProjetStatus(projet.user.participation._id,projet.projet._id,e.target.value)}}>
                                <option value="à valider">À valider</option>
                                <option value="validé">Validé</option>
                                <option value="refusé">Refusé</option>
                            </select>
                        </>}
                    </div> 
                )
            })}
        </div>
    );
};

export default FDProjetsList;